// implement your own methods in here, if your data is coming from A rest API
import axios from 'axios';


export const base = process.env.VUE_APP_BASE_URL_HOMABAY
export const token = process.env.VUE_APP_TOKEN;
export const paysol =  base+"/paysol/index.php";



export const county_logo = base +"/logo/county_logo.png"
export const login_bg = base +"/logo/bg-auth-overlay.png"

export const self_service_bg = base +"/logo/self_service_bg.png"
export const self_service_overlay = base +"/logo/self_service_overlay.png"


export const rent = base+"/rent/index.php";
export const parking =  base+"/parking/index.php";
export const trade =  base+"/trade/index.php";
export const biller =  base+"/biller/index.php";
export const authUrl =  base+"/authentication/";

export const plotRent =  base+"/plotrent/index.php";
export const plotRentUploads =  base+"/plotrent/uploads/";

export const landRate =  base+"/landrate/index.php";

export const fire =  base+"/fire/index.php";
export const health =  base+"/health/index.php";
export const housing =  base+"/housing/index.php";

export const liquor =  base+"/liquor/index.php";

export const uploadsLiqour = base+"/liquor/uploads/";


export const execute = (params, url) => {
  return axios.post(url, params, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
